"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nameTitle = void 0;
exports.nameTitle = { "MR": { "name": { "code": "MR", "localize": { "en": "Mr.", "th": "นาย", "id": "Mr." } } }, "MRS": { "name": { "code": "MRS", "localize": { "en": "Mrs.", "th": "นาง", "id": "Mrs." } } }, "MISS": { "name": { "code": "MISS", "localize": { "en": "Miss", "th": "นางสาว", "id": "Miss" } } } };
